//不要格式化
export default {
  home: {
    Login: 'Log in', // 登录
    Sign: 'Sign up', // 立即注册
    Slogan: 'Share every moment, Reward every moment', //分享每一刻 收获每一刻
    ImmedSign: 'Sign in', // 立即注册
    Enter: 'Enter CloudMaster', // 进入CloudMaster
    Signup: 'Register a FEEMOO account', // 注册飞猫盘账号
    Simple: 'Super easy registration', // 超简单极速注册
    Master: 'liberal CloudMaster', // 开通飞猫达人
    Exclusive: 'Exclusive logo/rights', //达人专属标识/权益
    ShareFile: 'Share files for revenue', // 分享文件赚收益
    Others: 'Others download/save and get paid', // 他人下载/转存即获得收益
    Advantages: 'Platform Advantages', // 平台优势
    Multiple: 'Multiple modes of flexible play', //多种模式灵活玩法多样
    CardTitle1: 'FEEMOO Rebate', // FEEMOO返利
    CardText1: 'FEEMOO is a sharing network disk, after becoming a master upload files, generate sharing links for others to download.', // 
    CardText1_2prefix: '', //可选择
    CardText1_2Blod: 'Download rebate model', //下载量返利模式
    CardText1_2suffix: ' can be selected, the size of the file according to the download rebate, the classification of 10,000 downloads up to 1888 yuan, every Wednesday and Thursday double revenue. ', //，区分大小文件按下载量返利，区分等级万次下载最高1888元，每周三、周四双倍收益。
    CardText1_3prefix: 'Or choose the ', //或选择
    CardText1_3Blod: 'member rebate model', //会员返利模式
    CardText1_3suffix: ', Do not charge according to the number of downloads, only according to the proportion of download users to open members, files do not expire, the page is more concise.', //，不按下载次数计费，只根据下载用户开通会员进行按比例分成，文件不过期，页面更简洁。
    CardTitle2: 'Promo code rebate', // 优惠码返利
    CardText2: 'Use your exclusive invitation code to invite users to open FEEMOO premium, you can get a rebate.', // 使用专属您的邀请码邀请用户开通飞猫盘会员，您可获得返利收益
    CardTitle3: 'Downline Rebate', // 下线返利
    CardText3: `Friends apply to become CloudMaster after registering FEEMOO account through invitation link, you can get the share rebate of friends' revenue.`, // 好友通过邀请链接注册飞猫盘账号后申请成为飞猫达人，您可获得好友收益的分成返利。
    Income: 'Real income', // 真实收益
    Random: `Random display of last week's partial income withdrawal record real withdrawal can be seen`, // 随机展示上周部分收益提现记录 真实提现看得到
    Feedback: 'Real user feedback', // 真实用户反馈
    Realization: 'Ten years of online traffic realization platform, real feedback', // 上线十年流量变现平台，真实反馈
    Enjoy: 'Enjoy the fun of sharing and easily earn\nyour share of realizing gains', // 享受分享的乐趣，轻松赚取属于你的变现收益。
  },
  nav: { //头部模块
    Login: 'Log in', //登录
    Sign: 'Sign up', //注册
    Account: 'Account', //个人账户
    SignOut: 'Sign Out', //退出
  },
  GradeColor: { //等级颜色
    Bronze:'Bronze',//青铜
    Silver:'Silver',//白银
    Gold:'Gold',//黄金
    Diamond:'Diamond',//钻石
    Master:'Master',//大师
    King:'King',//王者
  },
  IntrDaren: { //未登录展示
    FeeMooMaster: 'FEEMOO Master', //飞猫达人
    TextOne: 'Unlock a number of rebates after opening FEEMOO Master !', //开通成为飞猫达人后即可解锁多项推广返利功能！
    OpenVIP: 'Open Now', //立即开通
    PlatformPlay: 'Platform play', //平台玩法
    PlateRebate: 'FEEMOO plate rebate', //飞猫盘返利
    TextFive: 'Share files with other users to download/save for revenue', //分享文件给其他用户下载/转存获得收益
    PromoCodeRebate: 'Promo code rebate', //优惠码返利
    TextSix: 'Users get a rebate by opening a membership through a promo code', //用户通过优惠码开通会员获得返利收益
    DownlineRebate: 'Downline rebate', //下线返利
    TextSeven:
      'Invite friends to become a FEEMOO Master to get friends is share of the revenue', //邀请好友成为飞猫达人获得好友的收益分成
    ActivityRule: 'Activity rule', //活动规则
    TextTwo: 'The applicant should complete the information of the payee', //申请人需完善收款人信息
    TextThree: 'Platform rules need to be followed', //需遵守平台规则
    TextFour: 'User service agreement', //《飞猫盘用户服务协议》
  },
  FmCloud: { //飞猫盘模块
    DownloadRebateMode: 'Download rebate model', //下载量返利模式
    YouHave: 'You have', //您有
    FilesUsingMode: 'files using this mode', //个文件使用该模式
    MyGrade: 'My grade: ', //我的等级：
    TextOne:
      'Distinguish the size of the file according to the download rebate, distinguish the level of 10,000 downloads up to 1888 yuan, every Wednesday and Thursday double income', //区分大小文件按下载量返利，区分等级万次下载最高1888元，每周三、周四双倍收益
    DetailedIntroduction: ' detailed introduction.', //详细介绍
    LargeFileIncome: 'Large file income', //大文件收益
    SmallFileIncome: 'Small file income', //小文件收益
    TextTwo: 'Today more than 100M file downloads (times)', //今日大于100M文件下载量（次）
    TextThree: 'Today less than 100M file downloads (times)', //今日小于100M文件下载量（次）
    WeekAward: 'FEEMOO of the Week award', //每周飞猫达人奖
    TextFour: 'Automatic redemption to balance at 8am the next day', //次日上午8点自动兑换到余额
    NotYetAwarded: 'Not yet awarded', //暂未获奖
    ReceiveReward: 'Receive a reward', //领取奖励
    Claimed: 'Claimed', //已领取
    MemberRebateModel: 'Member rebate model', //会员返利模式
    TextFive: 'Prizes are awarded on Wednesdays', //每周三评奖
    TextSix:
      'Do not charge according to the VIP of downloads, only according to the proportion of download users to open members, files do not expire, the page is more concise', //不按下载次数计费，只根据下载用户开通会员进行按比例分成，文件不过期，页面更简洁
    RebateVIP: 'Rebate VIP', //返佣个数
    CommissionRebate: 'Commission rebate', //返佣金额
    VIPRebatesToday: 'VIP of rebates today', //今日返佣个数
    CommissionBackToday: 'Commission back today', //今日返佣个数
  },
  NavLeft: { //左侧菜单模块
    FEEMOO: 'Feemoo', //飞猫盘
    Fm2shortlink: 'Fm2 Short Link', // Fm2短链
    PromotionCode: 'Promotion code', //优惠码
    DownlineRebate: 'Downline rebate', //下线返利
    HelpCenter: 'Help center', //帮助中心
    BalanceWithdrawal: 'Balance', //余额提现
    AccountManagement: 'Settings', //账号管理
  },
  Fm2shortlinkbate: {
    Fm2link: 'Fm2 Short Link', //Fm2短链
    dataDetails: 'Detailed Data', //数据明细
    Fm2ShortLink: 'What is Fm2 Short Link?', // 什么是Fm2短链？
    LinkisaFast: 'Fm2 Short Link is a fast, secure URL shortener built for Chinese users. One click turns long links into clean “fm2.cc/d/” slugs, supports bulk creation and multiple share modes, and stacks with every CloudMaster product to monetize the same traffic several times over.',
    CreatetoShorten: 'Create Short Link',
    CreatetoShorten2: 'Enter URL to shorten',
    clickyourlin: "Share Short Link",
    clickyourlin2: "Others click your link",
    Earnmore: "Earn rewards",
    Earnmore2: "Unlock more to earn more",
    Fm2Earnings: 'Fm2 Short Link Earnings',
    Multiplemodels: 'Flexible sharing options',
    Directjump1: 'Direct Unlock (no login)：',
    Directjump2: 'clicks；',
    Directjump3: ' per 10k',
    Directjump4: '（lowest barrier, ideal for traffic bursts）',
    Loginjump1: 'Login Unlock：',
    Loginjump2: '',
    Loginjump3: ' per 10k',
    Loginjump4: ' unlocks; requires login',
    Miniadjump1: 'Mini-Program Ad Unlock：',
    Miniadjump2: '',
    Miniadjump3: ' per 10k',
    Miniadjump4: ' unlocks; watch ad in WeChat mini-program',
    Feemooadjump1: 'Feemoo App Ad Unlock：',
    Feemooadjump2: '',
    Feemooadjump3: ' per 10k',
    Feemooadjump4: ' unlocks; highest payout, Feemoo App required',
    Extrareferralbonus1: 'Referral Bonus：',
    Extrareferralbonus2: 'when users register through your link, you also earn Feemoo downline rewards',
    Extrareferralbonus3: '',
    DataOverview: 'Data Overview', //数据概览
    DataOverview2: 'Updated daily at 8 AM',
    ViewDetails: 'View Details', //查看详情
    YesterdayViews: 'Yesterday Views',
    YesterdayRedirects: "Yesterday's Unlocks",
    YesterdayEarnings: 'Yesterday Earnings',
    Yesterday: 'Successful unlocks via short link yesterday',
    RevenueExplanation: 'Revenue Explanation',
    Shortearnings: 'Short-link earnings：',
    payoutdepends: 'payout depends on the chosen revenue model; exact amounts are shown on the page.',
    Shortearningtitle: 'Multi-earnings：',
    Multiearnings: 'users who register via your Fm2 short link become your referrals and can trigger three extra rewards, calculated in parallel with short-link earnings.',
    Invalidtraffic: 'Invalid traffic：',
    emulators: 'clicks from scripts, emulators, bot farms, VPN proxies, or any artificial means are void and unpaid.',
    Rateadjustments: 'Rate adjustments：',
    thirdparty: 'if third-party ad platforms delay, deduct, or refuse payment, Feemoo will reduce payouts proportionally and post the reason and amount.',
    Violationpolicy: 'Violation policy：',
    original: 'if the original URL is reported or judged illegal, harmful, or sensitive, the short link will be locked and earnings zeroed. Appeals can be filed via Help Center.',
    RevenueModel: 'Share Mode', //分享模式
    UserSteps: 'User Steps',
    Earningsper: 'Earnings per 10k unlocks (RMB)',
    MultiEarnings: 'Multi-Earnings',
    NoLoginJump: 'No-Login Unlocks',
    Clicklogin: 'Click to Unlocks login',
    None: 'None',
    LoginJumps: 'Login for Instant Unlock',
    Loginredirect: 'Log in → click → unlock',
    Registervia: 'Register via short link → becomes referral',
    Miniprogram: 'Unlock after Mini-Program Ad',
    WeChatQR: 'Log in → scan WeChat → watch ad → auto-unlock',
    Appadjump: 'Unlock after App Ad',
    FeemooQR: 'Log in → scan Feemoo → watch ad → auto-unlock',
    Earnings: 'Earnings',
    Redirectst: 'Views/Unlocks',
    ViewsViews: 'Views',
    ViewsViewss: 'Unlocks',
    Directjump11: 'Direct Unlock (no login)',
    Loginjump11: 'Login for Instant Unlock',
    Miniadjump11: 'Unlock after Mini-Program Ad',
    Feemooadjump11: 'Unlock after App Ad',
  },
  MemberRebate: { //优惠码模块
    RebateCode: 'Rebate code', //返利优惠码
    IncomeData: 'Income data', //收益数据
    //返利优惠码模块
    rebateDisCode: {
      YourCurrentLevel: 'Your current level：', //您当前等级：
      Levels: 'Levels', //等级介绍
      CouponCodeDiscount: 'Coupon code discount', //优惠码折扣
      RebateRatio: 'Rebate ratio', //返利比例
      MyPromoCode: 'My promo code：', //我的优惠码：
      MyCode:'My promo code',//我的优惠码
      Copy: 'Copy', //复制
      CopyCode: 'Copy promo code', //复制优惠码
      MemberRebateIncome: 'Member rebate income', //会员返利收益
    },
    //收益数据模块
    incomeData: {
      MemberRebateProgram: 'Member rebate program', //会员返利计划
      TextOne: 'Users can earn money by opening a membership through the promo code', //用户通过优惠码开通会员，您可获得收益
      Levels: 'Levels', //等级介绍
      MyGrade: 'My grade: ', //我的等级：
      MemberRebateIncome: 'Member rebate income', //会员返利收益
      OpenMembership:'Open membership',//开通会员人数
      UserNickname: 'User nickname', //用户昵称
      OpeningTime: 'Opening time', //开通时间
      RebateAmount: 'Rebate amount', //返利金额
    },
  },
  OfflineRebate: { //下线返利模块
    InviteRegisterLink:'Invite to register link',//邀请注册链接
    IncomeData: 'Income data', //收益数据
    yuan:'￥',//元
    InvitationLink:{ //邀请注册链接
      Text:'Gameplay description',//玩法说明
      TextOne:'Friends through the invitation link to register the FEEMOO account after application Become a FEEMOO Master, you can get high friend income Rebates.',//好友通过邀请链接注册飞猫盘账号后申请成为飞猫达人，您可获得好友收益的高额返利。
      TextTwo:'• You need to register a FEEMOO account through your invitation link Gong, and apply to become a FEEMOO Master.',//需通过你的邀请链接注册飞猫盘账号成功，并且申请开通成为飞猫达人
      TextThree:'• When your friend becomes a master and gets a FEEMOO rebate, you can get a share of your friend is revenue.',//好友成为达人后获得飞猫盘返利收益，你就能获得好友的收益分成。
      TextFour:'• The more friends you invite to become masters, the more revenue points you get Okay, no caps on top.',//邀请越多好友成为达人，获得更多收益分成，上不封顶
      InviteNow:'Invite now',//立即邀请
      CopyInvitationLink:'Copy invitation link',//复制邀请链接
      SavePicture:'Save picture',//保存图片
      DownLineIncome:'Down-line income',//下线收益
      Save:'Save',//保存
      TodayEarnings:'Today is earnings',//今日收益
      Yesterday:'Yesterday',//昨日
      CurrentEarnings:'Current earnings',//本月收益
      SeeMore:'See more',//查看更多
      InvitationRecord:'Invitation record',//邀请记录
      UserNickname:'User nickname',//用户昵称
      TextFive:'Open CloudMaster',//是否开通飞猫达人
      InvitationTime:'Invitation time',//邀请注册时间
      TextSix:'Get a ¥99 downline rebate',//获得99元下线返利
      HaveOpened:'Have opened',//已开通
      HaveNotOpened:'Have not opened',//未开通
    },
    offIncomeData:{ //收益数据
      TodayEarnings:'Today is earnings',//今日收益
      YesterdayEarnings:'Yesterday is earnings',//昨日收益
      CurrentEarnings:'Current earnings',//本月收益
      TextOne:'Down line rebate income',//收益记录
      UserNickname:'User nickname',//用户昵称
      TextTwo:'Rebate amount (¥)',//返利金额（元）
      TextThree:'Why I have not received offline rebate revenue: ',//为什么我还没有获得下线返利收益：
      TextFour:'1, check the status of friends: please check the invitation record, confirm whether friends have become a FEEMOO master.',//1、检查好友状态：请查看邀请记录，确认好友是否已成为飞猫达人。
      TextFive:'2, wait for revenue settlement: If your friends are already FEEMOO, you need to wait for them to generate revenue and settle the next day before you can get a share of the rebate revenue.',//2、等待收益结算：若好友已是飞猫达人，需等待他们产生收益并在次日结算后，您才能获得返利收益分成。
    },
  },
  help: { //帮助中心模块
    FEEMOO:'Feemoo',//飞猫盘
    ShortLink:'Short Link',
    CouponCode:'Coupon Code',//优惠码
    DownlineRebate:'Downline Rebate',//下线返利
    ComplaintBox:'Complaint box',//意见箱
    ContactCustomer:'Contact customer',//联系客服
    fmp:{ //飞猫盘
      MembershipRebateModel: 'Membership Rebate Model', // 会员返利模式
      DownloadVolumeRebateModel: 'Download Volume Rebate Model', // 下载量返利模式
      DownloadUserExperience: 'Download User Experience:', // 下载用户体验
      NonMembers: 'Non-Members：', // 非会员
      FirstDownloa: 'First download is free; subsequent downloads require welfare points. If welfare points are exhausted, downloads can be made using download coupons or by watching videos, but with slower speeds. Files do not expire.',
      FirstDownloa2: "Free downloads with no limits, but slower speeds. Files don't expire, and the download page is simple.",
      Members: 'Members：' ,
      Downloadsuse: 'Downloads use membership download credits and offer extremely fast speeds.',
      Downloadsuse2: 'Enjoy extremely fast download speeds without using membership download credits.',
      EarningsRules: 'Earnings Rules：',
      Filesreategorized: "Files are categorized as large (≥100MB) or small based on size. Your influencer tier and earnings per download are determined by the previous day's download volume. Rewards are based on download volume, with a maximum of 1,888 yuan per 10,000 downloads. Double earnings are available on Wednesdays and Thursdays for this model.",
      Filesreategorized2: "Earn a 45% rebate on user payment amounts.",
      Filesreategorized3: "Earn a",
      Filesreategorized4: "rebate on user payments (max 100 RMB per transaction).",
      EarningsProfile:'Earnings profile',//收益简介
      TextOne:'Share files for other users to download/save you can earn revenue, daily income is automatically settled the next morning. ',//分享文件给其他用户下载/转存你就能获得收益，每日所得收益次日凌晨自动结算。
      TextTwo:'Download rebate model：',//下载量返利模式：
      TextThree:'Distinguish the size of the file according to the',//区分大小文件按
      TextFour:'download rebate',//下载量返利
      TextFive:'，distinguish the level of 10,000 downloads up to',//，区分等级万次下载最高
      TextSix:' ¥1,888',//1888元
      TextSeven:'，every Wednesday and Thursday',//，每周三、周四
      TextEight:' double',//双倍
      TextNine:' revenue.',//收益。
      TextTen:'Member rebate model：',//会员返利模式：
      TextEleven:'do not charge by download, only root According to the download user opens the membership to be',//不按下载次数计费，只根据下载用户开通会员进行按
      TextTwelve:'divided proportionally',//比例分成
      TextThirteen:'，the article The piece does',//，文件
      TextFourteen:' not expire',//不过期
      TextFifteen:', the page is more concise.',//，页面更简洁，适合
      TextSixteen:' large file',//大文件
      TextSeventeen:' sharing.',//分享。
      IncomeModelComparison:'Income model comparison',//收益模式对比
      Equity:'Equity',//权益
      DownloadsRebateModel:'Download rebate model',//下载量返利模式
      VIPRebateModel:'VIP Rebate Model',//会员返利模式
      MoreModes:'More modes coming soon',//更多模式即将上线
      DownloadRebateRules:'Download rebate model rules',//下载量返利模式规则
      RebateMechanism:'1、Rebate mechanism：',//1、返利机制：
      TextEighteen:' According to the level of talent and downloads generated on the day, the amount of rebate revenue will be automatically settled in the morning of the next day.',//按当日达人等级与当日所产生的下载量，在次日凌晨自动结算返利收益金额。
      levelRules:'2、Level rules：',//2、等级规则：
      TextNineteen:'According to the downloads generated yesterday to determine the master rebate level under this model, such as yesterday is downloads reached 302, then today is master level is gold.',//根据昨日所产生的下载量来确定该模式下的达人返利等级，例如昨日下载量达到302，则今日达人等级为黄金。
      doubleRevenue:'3、Double revenue：',//3、双倍收益：
      TextTwenty:'Every Wednesday, Thursday can get double download rebate revenue.',//每周三、周四可获得双倍的下载量返利收益。
      MemberRebateModel:'Member rebate model rules',//会员返利模式规则
      RebateMechanismTwo:'1、Rebate mechanism：',//1、返利机制：
      twentyOne:'After choosing the membership rebate model, users who download or transfer files via your shared link are bound to you for 24 hours. If they subscribe to a membership within that period, you earn a ',
      twentyTwo:' rebate (max 100 RMB per transaction)',//作为返利。
      multiplePurchaseRebate:'2、Multiple purchase rebate：',//2、多次购买返利：
      twentyThree:'Within the 24-hour binding period, each membership purchase by the user earns you a ',//在24小时绑定期内，用户若多次开通会员，每次开通会员金额的
      twentyFour:'rebate (max 100 RMB per transaction)',//均将作为您的返利。
      BindingRestrictions:'3、Binding restrictions：',//3、绑定关系限制：
      twentyFive:'Once a user has established a binding relationship with you, they will not be able to establish a new binding relationship with other talent within 24 hours.',//一旦用户与您建立了绑定关系，他们在24小时内将无法与其他达人建立新的绑定关系。
      discountCode:'4、Promo code rebate limit：',//4、优惠码返利限制：
      twentySix:"If a user signs up for membership with a promo code, you'll only receive the promo code rebate; membership rebate earnings won't stack.",//如果用户在开通会员时使用了优惠码，平台将根据优惠码的使用情况，向你发放相应的返利收益。
    },ntCode:{ //优惠码
      TextOne:'What is the promo code?',//什么是优惠码？
      TextTwo:'Friends through your promo code to open membership to enjoy discounts, while you can get high rebates; The higher the talent level, the larger the discount code.',//好友通过您的优惠码开通会员享折扣，同时您可获得高额返利；达人等级越高，优惠码折扣越大。
      MasterRating:'Master rating',//达人等级
    },
    rebate:{ //下线返利
      TextOne:'What is offline rebate?',//什么是下线返利？
      TextTwo:'When user A invites user B to register, User B becomes offline of User A：',//用户A邀请用户B注册，则用户B成为用户A的下线：
      TextThree:'The Platform will give User A an additional reward of 15% of the revenue obtained by User B in the promotion activities of the Cat Plate, which will continue to be valid.',//平台按用户B在飞猫盘推广活动中获得收益的15%额外给用户A奖励，持续有效。
      MasterRating:'Master rating',//达人等级
    },
    contactCust:{ //联系客服
      HotIssue:'Hot issue',//热门问题
      View:'View',//查看
      AdditionalHelp:'Additional Help',//其他帮助
      SubmitATicket:'Submit a Ticket',//提交工单
      SubmitNow:'Submit Now',//立即提交
      FeedbackHistory:'Feedback History',//反馈历史
      ViewHistory:'View History',//进入查看
      TextOne:'Contact customer service',//联系客服
      TextTwo:'Communicate online now',//立即在线沟通
      TextThree:'Problem not found? Click here to submit',//没找到问题，点此提交问题
      LatestAnnouncements:'Latest Announcements',//最新公告
      FAQ:'FAQ',//常见问题
      Back:'Back',//返回
      LoginRegister:'Login & Register',//登录注册
      WithdrawEarnings:'Income withdrawal',//收益提现
    },
  },
  IncomeReflect: { //余额提现模块
    BalanceWithdrawal:'Balance withdrawal',//余额提现
    WithdrawalRecord:'Withdrawal record',//提现记录
    PayeeManagement:'Payee management',//收款人管理
    tabZero:{ //余额提现
      withdrawableAmount:'Balance',//可提现金额
      Important: "Important: Recent adjustments to Alipay's payment risk control rules may affect some users' ability to receive payments. The platform recommends adding a bank card payee and using bank transfer for withdrawals temporarily.", //重要提示：近期支付宝支付风控规则调整，可能会影响部分用户的收款能力，平台建议添加银行卡收款人，暂时使用银行转账提现。
      yuan:'￥',//元
      Payee:'Payee',//收款人
      NewPayee:'Add New Payee',//新增收款人
      PleaseSelect:'Please select',//请选择
      CashWithdrawal:'Withdrawal',//提现金额
      TextOne:'Please enter the withdrawal amount',//请输入提现金额
      TextTwo:'Minimum ￥30 per withdrawal',//每笔提现最低30元
      phoneNumber:'Phone',//手机号
      PleasePhone:'Please enter your phone number',//请输入手机号
      VerificationCode:'Verification code',//验证码
      TextThree:'Enter mobile verification code',//请输入验证码
      TextFour:'Retrieve',//获取验证码
      Sent:'Sent',//已发送
      WithdrawCashNow:'Withdraw cash now',//立即提现
      TextFive:'You have not yet done mobile binding, the withdrawal will default after successful Bind this phone number',//您尚未进行手机绑定，提现成功后将默认绑定此手机号
      SelectAPayee:'Select a Payee',//请选择收款人
      TextSix:'Enter withdrawal amount',//请输入提现金额(每笔提现最低200元)
      yuana:')',
      WithdrawalRules:'Withdrawal Rules',//提现规则介绍
      TextSeven:'1.Withdrawal times: 9 per payee per 30 days.',//1.提现次数：账号可添加多个收款人，每个收款人每 30 天内最多可提现 9 次。
      TextEight:'2.Annual limit: 600,000 RMB per payee.',//2.累计限额：每个收款人每年累计提现金额最多为 60 万元人民币。
      TextNine:'3.Single limit: have a single transaction limit of 200–50,000 RMB.',//3.单笔限额：单笔提现金额上限为 5 万元人民币。
      TextTen:'4.Minimum Amount: Min. 200 RMB per withdrawal.',//4.最低提现金额：每笔提现金额不得低于 200 元人民币。
      tooltipSeven:'Withdrawal amount limit：',
      tooltipEight:'have a single transaction limit of 200–50,000 RMB.',
      tooltipNine:'Mainland bank card: 800–25,000 RMB.',
    },
    tabOne:{ //提现记录
      OrderNumber:'Order number',//订单号
      Amount:'Amount',//金额
      Status:'Status',//状态
      Time:'Time',//时间
      TextOne:'Withdrawal record is empty ~',//提现记录为空~
      awaitingProcessing:'Pending',//待处理
      Successful:'Successful',//成功
      Fail :'Fail',//失败
      ViewCauses :'View Causes',//查看原因
    },
    tabTwo:{ //收款人管理
      NewPayee:'New payee',//新增收款人
      UserNickname:'User nickname',//用户昵称
      AlipayAccount:'Alipay account',//支付宝账号
      IdNumber:'Id number',//身份证号
      TextOne:'Monthly withdrawal limit',//当月提现额度
      Controls:'Controls',//操作
      Editor:'Editor',//编辑
      Delete:'Delete',//删除
      NoRecord:'No record',//暂无记录
      PaymentMethod:'Payment Method',//收款方式
      PaymentAccount:'Payment Account',//收款账号
      AnnualWithdrawalLimit:'Yearly Limit',//年度可提现额度
      MonthlyWithdrawalCount:'Withdrawal times in last 30 days',//近30天内已提现次数
    }
  },
  Account: { //账号管理模块
    TextOne:'Consult customer service',//咨询客服了解更多
    ContactCellPhone:'Contact cell phone',//联系手机
    ContactEmail:'Contact email',//联系邮箱
    FEEMOOCertification:'FEEMOO  Certification',//飞猫达人认证
    FEEMOOCertificationTwo:'CloudMaster',//CloudMaster
    SubscriptionNumberOpening:'Subscription number opening',//订阅号开通
    CertifiedFEEMOOMaster:'Certified FEEMOO Master',//已认证飞猫达人
    CertifiedFEEMOOMasterTwo:'Uncertified CloudMaster',//未认证CloudMaster
    TextTwo:'Subscription number has been opened',//已开通订阅号
    TextThree:'Modify Bound Phone',//修改绑定手机
    TextFour:'Modify Bound Mailbox',//修改绑定邮箱
    Accredited:'Accredited',//已认证
    TextFive:'Go to Subscription',//进入订阅号
    BoundPhone:'Bound Phone',//绑定手机
    BoundMailbox:'Bound Mailbox',//绑定邮箱
    UncertifiedFEEMOO:'Uncertified FEEMOO',//未认证飞猫达人
    GetCertified:'Get certified',//去认证
    SubscriptionNotAvailable:'Subscription not available',//未开通订阅号
    GoAndActivate:'Go and Activate',//去开通
    NotActivated:'Not Activated',//未开通
    ActivateNow:'Activate Now',//立即开通
    ActivatedNEW:'Activated',//已开通
  },
  LevelTable: { //等级表格
    ClassInterest:'Class interest',//等级权益
    DownloadsYesterday:'Downloads yesterday',//昨日下载量
    TextOne:'Large file rebates (¥/million)',//大文件返利（元/万次）
    TextTwo:'Rebate for small files (¥/million)',//小文件返利（元/万次）
    CouponCodeDiscount:'Coupon code discount',//优惠码折扣
    PromoCodeRevenue:'Promo code revenue',//优惠码收益
  },
  TablePublic: { //表格组件模块
    UserNickname: 'User nickname', //用户昵称
    OpeningTime: 'Opening time', //开通时间
    RebateAmount: 'Rebate amount', //返利金额
    NoRecord: 'No record', //暂无记录
    QRCode: 'QRCode', //二维码
    InvitationCode: 'Invitation code', //邀请码
    InvitationLink: 'Invitation link', //邀请链接
  },
  MemRbCom: { //会员返利收益组件
    Today: 'Today', //今日
    Yesterday: 'Yesterday', //昨日
    CurrentEarnings: 'Current earnings', //本月收益
    yuan: '￥', //元
  },
  userNew: { // 信息悬浮框模块
    All: 'All', // 全部
    SystemNotification: 'System', // 系统通知
    OfficialNews: 'Official', // 官方消息
    ReadAll: 'Read All', // 全部已读
    Nonews: 'No news', // 暂无消息
  },
  exPand:{
    referralProgram:'Referral program',//引荐计划
    exTextOne:'What is a referral program?',//什么是引荐计划？
    exTextTwo:'Refer users to register for Feemoo and become your downline to earn three rewards: download coupons, membership duration rewards or revenue sharing from membership purchases, and downline rebate earnings.',//引荐用户注册Feemoo账号成为你的下线可同时获得三重奖励：下载券、会员时长奖励或开通会员收益分成、下线返利收益。
    InvitationMethods:'Invitation Methods',//邀请方式
    exTextThree:'Each invite link can register aFeemooaccount, making it easier to bring in new users. Try different promotional methods to attract more referrals!',//每个邀请链接都能注册Feemoo账号，拉新更轻松。换个宣传方式，吸引更多人成为你的下线！
    exTextFour:'IntroduceFeemoofeatures to encourage referrals to subscribe',//介绍Feemoo功能，吸引下线开通会员
    CopyInviteLink:'Copy invite link',//复制邀请链接
    exTextFive:"Explain CloudMaster's various rebate earnings to encourage referrals to activate CloudMaster",//介绍CloudMaster多种返利收益，吸引下线开通CloudMaster
    exTextSix:'Reward 1: Invitation Sign-Up Bonus',//奖励一：邀请注册奖励
    InviteHistory:'Invite History',//邀请记录
    NumberofInvitedReferrals:'Number of Invited Referrals',//已邀请下线人数
    ValidInvites:'Valid Invites',//有效邀请人数
    TotalRewards:'Total Rewards',//累计奖励
    users:'users',//人
    Sheet:'Sheet',//张
    Days:'Days',//天
    money:'¥',//元
    ci:'per',//次
    exTextSeven:'·Valid invite after registering a Feemoo account, binding a phone number, and logging into the app or desktop client the next day',//·注册Feemoo账号并绑定手机号在次日登录APP或桌面客户端后视为有效邀请
    exTextEight:'·One device/account is counted as one new referral;Feemoo filters abnormal data.',//·同一台设备、同一个账号仅会被计算为被邀请的新下线用户一次，Feemoo 官方会过滤异常数据
    exTextNine:'Get 5 download coupons per valid invite, up to 50 new users.',//首次奖励3天体验会员时长，后续每次奖励1天体验会员时长，最多累计
    exTextTen:'up to 50 new users.',//获得50位新用户邀请奖励。
    exTextEleven:'Reward 2: Referral Membership Activation',//奖励二：下线开通会员
    CurrentRewards:'Current rewards:',//当前奖励方式：
    Membershipduration:'Membership duration',//会员时长奖励
    ActivationAmount:'Activation amount',//开通金额奖励
    PendingRewards:'Pending rewards',//待处理奖励
    ReceivedRewards:'Received rewards',//已到账奖励
    TotalRewards:'Total rewards',//累计奖励
    EarningsRecords:'Earnings records',//收益记录
    TodayEarnings:"Today's earnings",//今日收益
    YesterdayEarnings:"Yesterday's earnings",//昨日收益
    TotalEarnings:'Total earnings',//累计收益
    exTextTwelve:'Reward 3: Downstream Rebates',//奖励三：下线返利
    Rules:'Rules',//规则说明
    RewardRules:'Reward rules',//奖励规则
    RewardOne:'Reward One:',//奖励一：
    exTextThirteen:'When the first new user invited via your link registers for a Feemoo account, binds their phone number, and logs in to the app or desktop client the next day, you will receive 3 days of trial membership. For each subsequent new user you invite, you will get 1 day of trial membership.',//通过您链接邀请的第一位新用户注册Feemoo账号并绑定手机号在次日登录APP或桌面客户端后，首次邀请您可获得3天体验会员时长，后续您每邀请1位可获得1天体验会员时长
    RewardTwo:'Reward Two: ',//奖励二：
    exTextFourteen:'New users who register for a Feemoo account via your link and log in will become your downstream users. If they make a successful Feemoo Premium purchase within 3 months (90 days), you can opt for a reward based on membership duration or 20% of the actual amount paid.',//通过您链接邀请的新用户注册Feemoo账号登录后，将成为你的下线，其在 3 个月（90天）内每次成功购买Feemoo会员，您可选择按会员时长奖励或实付金额的 20% 获得奖励。
    exTextFifteen:'For instance, if your downstream user buys a monthly Premium membership four times within 3 months, you will be given either 24 days of monthly membership or a rebate of ¥24. If they purchase a Permanent membership, you will receive either 77.6 days of trial membership or a rebate of ￥77.6.',//例如：若您的下线 3 个月内购买 4 次月度会员，您将获赠 24 天月度会员时长或 24 元返利收益；若其购买不限时长会员，您将获赠 77.6 天体验会员时长或 77.6 元返利收益。
    RewardThree:'Reward Three: ',//奖励三：
    exTextSixteen:"When a new user invited via your link registers for a Feemoo account, logs in, successfully activates CloudMaster, and completes the Feemoo rebate settlement, you will receive 15% of that downstream user's earnings.",//通过您链接邀请的新用户注册Feemoo账号登录后，成功开通CloudMaster并完成Feemoo返利收益结算，您即可获得该下线用户收益的 15% 分成。
    ExpandDownstreamMode:'Expand Downstream Mode: ',//扩充下线模式：
    exTextSeventeen:'In addition to your exclusive invitation link, you can also expand your downstream network by sharing file links through the Expand Downstream Mode. This allows more people to register and become your downstream users.',//除专属邀请链接外，您也可通过扩充下线模式的文件链接分享给其他人注册来扩充更多下线。
    AssessmentCriteria:'Assessment Criteria',//判定细则
    exTextEighteen:'Rewards for downstream users purchasing Premium memberships will be added to pending earnings within 30 minutes. ',//下线用户购买会员的开通奖励会在 30 分钟内发放到待处理收
    exTextNineteen:'Qualified revenue-sharing rewards will be available for withdrawal after 7 days, ',//益，符合条件的分成奖励需等待7天后才可到账提现，
    exTextTwenty:'with possible delays in special cases.',//特殊情况可能会延迟。
    exTextTwentyOne:'New users must register for a Feemoo account via your exclusive invitation link, bind their phone number, and log in to the app or desktop client the next day to be considered a valid invitation.',//新用户需通过您的专属邀请链接注册Feemoo账号并绑定手机号在次日登录APP或桌面客户端后，才视为有效邀请。
    exTextTwentyTwo:'As the referrer, you will receive the new user registration reward for the first 50 valid invitations only. After this limit is reached, you will no longer receive this reward. However, there are no limits on the revenue - sharing rewards from purchasing Premium memberships or downstream rebates; these are uncapped.',//您作为上线用户，邀请下线用户的新用户注册奖励，仅限前50位有效邀请。超出后，上线用户不再获此奖励，但购买会员的分成奖励与下线返利无次数、人数限制，上不封顶。
    exTextTwentyThree:'The statistical data for Reward One begins on May 30, 2025. New users you invited before this date are not eligible for this reward.',//奖励一的统计数据起始时间为2025年5月30日，您在该时间之前邀请的新用户无法获得该奖励。
    exTextTwentyFour:'If a downstream user purchases a Premium membership through official channels or in - app purchases within 3 months (90 days) of registration, it is considered a successful membership purchase. Free memberships obtained through free exchanges or rewards do not count as purchased memberships.',//下线用户自注册起3个月（90天）内，通过官方渠道会员订阅或APP内购开通会员，视为成功购买会员。而通过免费兑换、奖励等获得的免费会员资格，不视为购买会员。
    exTextTwentyFive:'For downstream users who register via your invitation link, if they use a promo code to activate their Premium membership, you will only receive the promo code rebate. Reward Two will not be stacked.',//通过您的邀请链接注册账号的下线用户，如果用户使用优惠码开通会员，您只能获得优惠码返利，奖励二将无法叠加。
    exTextTwentySix:'If a downstream user who registers via your invitation link downloads the membership rebate mode file and activates their Premium membership within 24 hours, you will only receive the membership rebate mode benefits. Reward Two will not be stacked.',//通过您的邀请链接注册账号的下线用户，如果下载会员返利模式文件并在24小时内开通会员，你只能获得会员返利模式收益，奖励二无法叠加。
    exTextTwentySeven:'The statistical data for Reward Two begins on May 30, 2025. If a downstream user you invited within the last 3 months (90 days) activates their Premium membership after May 30, 2025, you will still receive this reward.',//奖励二的统计数据起始时间为2025年5月30日，近3个月（90天）内您邀请的下线用户在2025年5月30日后开通会员，您仍可获得该奖励。
    exTextTwentyEight:'Downstream users you invited before May 30, 2025, are still eligible for this reward.',//您在2025年5月30日之前邀请的下线用户仍可获得该奖励。
    OtherNotes:'Other Notes',//其他说明
    exTextTwentyNine:"Invite rewards and referral rebates will be credited to your account within 48 hours. Membership purchase rewards from referrals will be added to pending rewards within 30 minutes. Eligible revenue-sharing rewards will be available for withdrawal after 7 days, though special cases may cause delays.",//邀邀请奖励与下线返利将在48小时内发放至当前用户账号；下线用户购买会员的开通奖励会在30分钟内发放到待处理奖励，符合条件的分成奖励需等待7天后才可到账提现，特殊情况可能会延迟。
    exTextThirty:'Trial membership durations from rewards will be automatically added to your account. Check system notifications for specific timing.',//通过奖励所获得的体验会员时长，将自动发放到当前用户账号，具体发放时间请查看系统通知。
    exTextThirtyOne:'You cannot upgrade trial membership durations to unlimited ones by paying the difference.',//通过奖励所获得的体验会员时长，无法通过补差价升级为不限时长会员。
    exTextThirtyTwo:'Each device and account can only be counted as a new referral once. Feemoo will filter out abnormal data.',//同一台设备、同一个账号仅会被计算为被邀请的新下线用户一次，Feemoo 官方会过滤异常数据。
    exTextThirtyThree:'Feemoo has the right to disqualify participants for violations like malicious volume brushing or simulated user behavior. Penalties include reclaiming rewards and account suspension. Appeals can be made via the help center.',//对于违规行为（包括但不限于恶意刷量、违规折现、模拟用户行为等），Feemoo官方有权取消参与者的活动资格，并采取收回奖励、封禁账号等措施。如有异议，可通过帮助中心提交问题申诉。
    exTextThirtyFour:"Some low-version APP users won't get referral program rewards to better detect malicious volume brushing.",//为更准确识别恶意刷量，部分低版本 APP 注册用户将无法获得引荐计划活动奖励。
    exTextThirtyFive:"If we've paid you earnings but you or your referral violate our agreement, we may deduct previously paid earnings from your future earnings.",//如果我们已向您发放了收益，但您或您的下线用户违反了我们的用户协议或规则，则我们会保留从应向您发放的未来收益中扣除已支付收益的权利。
    exTextThirtySix:'This promotion is only for Feemoo users. Feemoo reserves the final interpretation rights.',//此活动仅限Feemoo用户参加，最终解释权归Feemoo官方所有。
    HeadTo:'Head to ',//前往
    exTextThirtySeven:' to create a share and select the download volume rebate mode',//创建分享选择下载量返利模式
    exTextThirtyEight:'Other users download files via your shared link.',//其他用户通过分享链接
    exTextThirtyNine:'Differentiate between large and small files and offer rebates based on download volume.',//下载文件成功
    exTextForty:'Double the earnings every Wednesday and Thursday!',//每周三、周四双倍收益！
    exTextFortyOne:'Other users establish a binding relationship after successfully downloading files via the shared link.',//其他用户通过分享链接下载文件成功后建立绑定关系
    exTextFortyTwo:'Users who already have a binding relationship and upgrade to Premium within 24 hours.',//已有绑定关系的用户24小时内开通会员
    exTextFortyThree:'You receive a portion of the revenue from users with a binding relationship who upgrade to Premium.',//你获得绑定关系用户
    ExpandReferralsMode:'Expand referrals mode',//扩充下线模式
    exTextFortyFour:'Register via the shared link to become a new user and establish a downstream relationship.',//通过分享链接注册成为新用户后建立下线关系
    exTextFortyFive:'The more downstream users you have, the more you can earn from the ',//更多的下线让你
    exTextFortySix:'referral program',//引荐计划
    exTextFortySeven:'.',//中获得更多收益
    exTextFortyEight:'New downstream users added today:',//今日新增下线人数
    exTextFortyNine:'Cumulative downstream users:',//累计下线人数
    exTextFifty:' to create a share and select the member rebate mode',//创建分享选择会员返利模式
    exTextFiftyOne:' to create a share and select the expand referrals mode',//创建分享选择扩充下线模式
    exTextFiftyTwo:'Go to referral program',//前往引荐计划
    exTextFiftyThree:'Go Check',//去查看
    exTextFiftyFour:'New downstream users',//去查看
    exTextFiftyFive:'Register a Feemoo account through the file link you shared, and the new user will become your downline',//通过你分享的文件链接注册Feemoo账号，新用户将成为你的下线
    exTextFiftySix:"Activation rewards for downstream users' Premium purchases are added to pending earnings within 30 minutes. Revenue-sharing rewards are available for withdrawal after 7 days, with possible delays.",//下下线用户购买会员的开通奖励会在30分钟内发放到待处理奖励，符合条件的分成奖励需等待7天后才可到账提现，特殊情况可能会延迟。
  },
}
